module.exports = __webpack_public_path__ + "static/img/Femoire_logo.680bc58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/Femoire_logo.png
// module id = gdwr
// module chunks = 0